import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import Sustainability from './pages/Sustainability';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/urunler" element={<Products />} />
          <Route path="/urunler/:category" element={<Products />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/hakkimizda/:section" element={<About />} />
          <Route path="/surdurulebilirlik" element={<Sustainability />} />
          <Route path="/surdurulebilirlik/:section" element={<Sustainability />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<Blog />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/kariyer" element={<About />} />
          <Route path="/kalite" element={<About />} />
          <Route path="/sertifikalar" element={<About />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
